import { useAuth } from './useAuth'
import { useStores } from './useStores'
import { Modal } from 'antd'

export const useValidateAuth = () => {
  const { store } = useStores()
  const { isLogin } = useAuth()

  const validateIsLogin = () => {
    if (!isLogin) {
      store.modal?.setLoginVisible(true)
      return false
    }

    return true
  }

  return {
    validateIsLogin,
  }
}
